export default __webpack_public_path__ + "static/media/metabase.e8865325.svg";